import Axios from "axios";
import { useEffect, useReducer } from "react";
import { dataFetchReducer } from "./data";
import { getConfiguration, getAggregationAndBetFromBetIdAndSportId, formatDate } from "./utils";
import { systemCode, xs_languageCode } from '..';
import { parseBetsData, getAggregateAllId } from "./parseBetsData";

function parseResponse(match, betsContainer, parseMatchData, frontendPageType) {
	if(parseMatchData){
		match.desc = betsContainer.dsl[xs_languageCode];
		match.matchId = betsContainer.bid;
		match.timestamp = betsContainer.ts;
		match.date = formatDate(betsContainer.ts).formatted;
		match.alias = betsContainer.al;
		const teams = match.desc.split(' - ');
		match.team1 = teams[0];
		if(teams.length > 1){
			match.team2 = teams[1];
		}
	}
	// create a list of aggregates containing just those bets
	const aggregatesMap = {};
	const rawBets = betsContainer.scs;
	for(let kb in rawBets){
		const bet = rawBets[kb];
		let aggregate = getAggregationAndBetFromBetIdAndSportId(match.sportRef, bet.cs, bet.h).aggregation;
		if(!aggregate && bet.h != 0){
			aggregate = getAggregationAndBetFromBetIdAndSportId(match.sportRef, bet.cs, 0).aggregation;
		}
		if(aggregate){
			aggregatesMap[aggregate.idAggregata] = aggregate;
		}
	}
	const aggregatesIds = [];
	for(let ka in aggregatesMap){
		aggregatesIds.push(aggregatesMap[ka].idAggregata)
	}
	const allId = getAggregateAllId(match.sportRef, false);
	aggregatesIds.push(allId);
	const betsData = parseBetsData(match, aggregatesIds, allId, rawBets, false);
	if(betsData.gruppiScommessa.length > 0){
		if(betsData.gruppiScommessa[0].idAggregata === allId && frontendPageType !== 'xsport_mobile_2'){
			const allAgg = betsData.gruppiScommessa.shift();
			betsData.gruppiScommessa.push(allAgg); // "All" aggregate must be the last one
		}
	}
	return {
        match,
        betsData,
        rawBets,
        aggregatesIds
	};
}

export function useFetchBetBuilderMatchBets(match, shouldExecute, reload, parseMatchData, frontendPageType) {
    const [state, dispatch] = useReducer(dataFetchReducer, {
        isLoading: true,
        isError: false,
    });
    
    useEffect(() => {
        if (!shouldExecute) {
            return;
        }
        
        let didCancel = false;

        const fetchData = async (url, params, callback) => {
            dispatch({ type: 'FETCH_INIT' });
            try {
                const result = await Axios.get(url, {params});
                if (!didCancel) {
                    callback(result.data);
                }
            } catch (error) {
                console.error('Errore ' + url + ': ' + error);
                if (!didCancel) {
                    dispatch({ type: 'FETCH_FAILURE' });
                }
            }
        };

        const url = getConfiguration().api.getBetBuilderEventBets;
        const params = {
            systemCode,
            lingua: xs_languageCode,
            hash: '',
            pal : match.pal,
            avv : match.avv
        }
        fetchData(url, params, function(response) {
            if (response == null || response === '') {
                dispatch({ type: 'FETCH_FAILURE' });
            }
            const betBuilderMatchBets = parseResponse(match, response, parseMatchData, frontendPageType);
            dispatch({ type: 'FETCH_SUCCESS', payload: betBuilderMatchBets });
        });
        
        return () => {
            didCancel = true;
        };
    }, [match, shouldExecute, reload]);

    return [state, dispatch];
}